// extracted by mini-css-extract-plugin
module.exports = {"Background":"BoxSwitch_Background__1bL5X","Background2":"BoxSwitch_Background2__3Inpd","Area":"BoxSwitch_Area__180GI"};